"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbilitySoundEffectVfxStepArgs = void 0;
const uuid_1 = require("uuid");
class AbilitySoundEffectVfxStepArgs {
    constructor(subjectId, ability, on, from) {
        this.subjectId = subjectId;
        this.ability = ability;
        this.on = on;
        this.from = from;
        this.__typeName = "AbilitySoundEffect";
        this.id = (0, uuid_1.v4)();
    }
}
exports.AbilitySoundEffectVfxStepArgs = AbilitySoundEffectVfxStepArgs;
